module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center3"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_c('b', [_vm._v("Get in on the fun by posting pictures to Instagram using #dessertmashups and tagging @crazyforcrust!")])])])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "550",
      "src": "images/f0006-01.jpg",
      "width": "413"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdef1f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Frontmatter.vue
// module id = 72
// module chunks = 0